<template>
    <v-container fluid style="background-color: white;">
        <v-row align="center" class="mx-4">
            <v-col>
                <v-text-field v-model="qrCodeCount" label="Number of codes to genererate" type="number">
                </v-text-field>
            </v-col>
            <v-col>
                <v-btn color="primary" small :disabled="isLoading" :loading="isLoading" @click="generateCodes()">
                    Generate more codes
                </v-btn>
                <v-btn color="secondary" small class="mx-2" :disabled="isLoading || !qrList || !qrList[0]" @click="downloadAsJson()">Download as Json</v-btn>
            </v-col>
        </v-row>
        <template>
        <v-progress-linear v-if="progress" :value="progress" absolute style="z-index: 31">
        </v-progress-linear>
        </template>
        <v-row class="my-3" justify="center" >
            <centered-loading v-if="isLoading" :displayBool="true" :completedBool="false" style="position: absolute; height: 100%; background-color: #ffffffba; z-index: 30;">
            </centered-loading>
            <template>
                <v-col cols="auto" v-for="(qr, index) in qrList" :key="index" align="center">
                    <QrLabelCard :companySettings="companySettings" :qrLink="qr.Link" :qrText="qr.QrCode">
                    </QrLabelCard>
                </v-col>
            </template>
        </v-row>
    </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import QrLabelCard from '@/components/Cards/QrLabelCard.vue';
import CenteredLoading from "@/components/Sections/CenteredLoading.vue";

export default {
    name: 'QrCodes',
    props: {},
    components: {
        CenteredLoading,
        QrLabelCard,
    },

    data() {
        return {
            isLoading: false,
            companySettings: {
                AddressZipAndCity: { key: "ServiceProvider.AddressZipAndCity", value: "" },
                Telephone: { key: "ServiceProvider.Telephone", value: "" },
                CompanyName: { key: "ServiceProvider.CompanyName", value: "" },
                AddressStreet: { key: "ServiceProvider.AddressStreet", value: "" },
                Email: { key: "ServiceProvider.Email", value: "" },
            },
            logo: {},
            qrCodeCount: 5,
            qrList: [],
            progress: 0,
        };
    },

    mounted() {
        this.fetchCompanySettings();
    },

    methods: {
        downloadAsJson(){
            var dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(this.qrList, null, 2));
            var downloadAnchorNode = document.createElement('a');
            downloadAnchorNode.setAttribute("href",     dataStr);
            downloadAnchorNode.setAttribute("download", "qr-codes.json");
            document.body.appendChild(downloadAnchorNode); // required for firefox
            downloadAnchorNode.click();
            downloadAnchorNode.remove();
        },

        fetchCompanySettings() {
            const group = 'serviceprovider';
            this.isLoading = true;
            clientAPI.methods.getSettingsListByGroup({ groups: [group] }).then(response => {
                const groupResponse = response[group];
                this.companySettings.AddressZipAndCity.value = groupResponse[this.companySettings.AddressZipAndCity.key];
                this.companySettings.Telephone.value = groupResponse[this.companySettings.Telephone.key];
                this.companySettings.CompanyName.value = groupResponse[this.companySettings.CompanyName.key];
                this.companySettings.AddressStreet.value = groupResponse[this.companySettings.AddressStreet.key];
                this.companySettings.Email.value = groupResponse[this.companySettings.Email.key];
                this.isLoading = false;
            });

        },
        
        async generateCodes() {
            this.isLoading = true;
            this.qrList = [];
            const takeCount = 200;
            var counter = this.qrCodeCount;
            while (counter) {
                this.progress = ((this.qrCodeCount - counter) / this.qrCodeCount * 100) || 5;
                var take = counter > takeCount ? takeCount : counter;
                counter = counter - take;
              
                await clientAPI.methods.generateQrCodeList(take).then(response => {
                    this.qrList.push(...response);
                });
            }
            this.progress = 0;
            this.isLoading = false;
        },
    },

    computed: {},

    watch: {},
};
</script>


<style lang='scss' scoped></style>